import { Col, Icon, Menu, Modal, Row, Tabs, Tooltip, Button } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onTab } from './../../actions/ordersAction';
import { convertDateFromUTC, convertDateToUTC } from './../../services/dst';
import { orderStatus } from './../../constants';
import './styles.css';
import iconHistory from './../../resources/assets/images/history_import.png'
import iconHistoryNotification from './../../resources/assets/images/history_import_notification.png'
import ImportHistoryOrder from './../../containers/orders/importHistory';
import { getImportedBackgroundFlag } from '../../utils/orders';
import hanldeException from '../../services/handleException.js';

const TabPane = Tabs.TabPane
const confirm = Modal.confirm
class MenuStatus extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ihoVisible: false // import history order
        }
    }

    /**
     * Handle show popup import history
     */
    showImportHistory = (e) => {
        this.setState({
            ihoVisible: true
        });
    }

    /**
     * Handle close popup import history
     */
    closeImportHistory = (e) => {
        this.setState({
            ihoVisible: false
        });
    }

    render() {
        getImportedBackgroundFlag().then(res => {
            if(res.data.data == true){
                this.importedBackgroundFlag = true;
            }else{
                this.importedBackgroundFlag = false;
            }
        }).catch(error => {
            hanldeException(error)
        });

        return (
            <Row id="menu-status">
                <Col span={7}>
                    <div style={{ lineHeight: "68px" }}>
                        <div className="title-order">Orders</div>
                        <div className="line-h"></div>
                    </div>
                    <div className="sync">
                        <div className="date">
                            <div className="history-text">
                                Last Update:<br/>
                                {this.props.lastUpdateTime ? <span>{convertDateFromUTC(this.props.lastUpdateTime).format('MM/DD/YYYY HH:mm')}</span> : ''}
                            </div>
                            <div className="history-icon">
                                <div>
                                    <Tooltip title="Import history">
                                        <img id='icon-import-amazon' src={this.importedBackgroundFlag ? iconHistoryNotification : iconHistory}
                                        onClick={e => this.showImportHistory(e)} />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col span={17}>
                    <Tabs
                        activeKey={(this.props.status_list.length == 1) ? (this.props.status_list[0].toString()) : ''}
                        className="order-tab-panel"
                        onChange={key => this.props.onTab({ tab: key, PageSize: this.props.getOrderParams.PageSize })}
                    >
                        <TabPane tab={'Awaiting Finalization (' + this.props.AwaitingFinalizationTotal + ')'} key={orderStatus.AWAITING_FINALIZATION} />
                        <TabPane tab={'Awaiting Shipment (' + this.props.AwaitingShipmentTotal + ')'} key={orderStatus.AWAITING_SHIPMENT} />
                    </Tabs>
                </Col>

                {/* popup show import history */}
                <Modal
                    title="Import History"
                    visible={this.state.ihoVisible}
                    maskClosable={false}
                    centered={true}
                    onCancel={this.closeImportHistory}
                    className="modal-history-detail modal-history modal-import-order"
                    footer={[
                        <Button className="btn-opt" key="submit" type="primary" onClick={this.closeImportHistory}>
                          OK
                        </Button>
                    ]}
                >
                    <ImportHistoryOrder isVisible={this.state.ihoVisible} />
                </Modal>
            </Row>
        )
    }
}

const mapStateToProps = state => {
    return {
        active_tab: state.ordersReducer.active_tab,
        status_list: state.ordersReducer.input_filter.status_list,
        getOrderParams: {
            Status: state.ordersReducer.input_filter.status_list,
            FulfillOption: state.ordersReducer.input_filter.fulfill_option,
            OrderDateFrom: convertDateToUTC(new Date(state.ordersReducer.input_filter.from + ' 00:00:00')),
            OrderDateTo: convertDateToUTC(new Date(state.ordersReducer.input_filter.to + ' 23:59:59')),
            OrderBy: state.shipmentReducer.orderBy,
            IsDesc: state.ordersReducer.isDesc,
            PageSize: state.ordersReducer.offset,
            Page: state.ordersReducer.current_page,
            ChannelOrderID: state.ordersReducer.input_filter.channel_order_no,
            ChannelID: state.ordersReducer.input_filter.channel,
        },
        Summary: state.headerReducer.Summary,
        AwaitingFinalizationTotal: state.ordersReducer.AwaitingFinalizationTotal ? state.ordersReducer.AwaitingFinalizationTotal : 0,
        AwaitingShipmentTotal: state.ordersReducer.AwaitingShipmentTotal ? state.ordersReducer.AwaitingShipmentTotal : 0,
        lastUpdateTime: state.ordersReducer.lastUpdateTime
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onTab: payload => {
            dispatch(onTab(payload))
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuStatus)



// WEBPACK FOOTER //
// ./src/components/menu-status/index.js